import HttpRequest from '@/utils/request'
import { SERVER_BASE_URL } from '@/config'
const baseUrl = SERVER_BASE_URL //  config.baseUrl.dev
//   process.env.NODE_ENV === 'development'
//     ? config.baseUrl.dev
//     : config.baseUrl.pro

const axios = new HttpRequest(baseUrl)
export default axios
